import { IErrorResponse } from "@api";
import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ID } from "@types";
import {
  IGetServiceProviderOptions,
  getRepeatRateMetrics,
} from "../services/serviceProviders";

interface IUseContextOptions extends IGetServiceProviderOptions {
  onError?: (error: IErrorResponse) => void;
}

export const useRepeatRates = (
  serviceProviderId: ID | undefined,
  options?: IUseContextOptions
) => {
  const { data, isLoading, isError, isSuccess, status, refetch, error } =
    useDataQuery(
      ["repeatRates", Number(serviceProviderId), options],
      async () => {
        const response = await getRepeatRateMetrics(serviceProviderId, options);
        return response.data;
      },
      {
        enabled: !!serviceProviderId,
      }
    );

  return { data, isLoading, isError, isSuccess, status, error, refetch };
};
